import axios from "axios";
import { getVisitorId } from "@/lib/visitor";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Visitor-Id"] = getVisitorId();
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("jt_token");
      const p = window.location.pathname;
      if (p.startsWith("/admin") && !p.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);
